<template>
	<transition name="fade" v-bind="$attrs" v-on="$listeners" mode="out-in">
		<slot></slot>
	</transition>
</template>

<style scoped>
	.fade-enter-active, .fade-leave-active {
		transition: opacity 0.25s ease;
	}

	.fade-enter, .fade-leave-to  {
		opacity: 0;
	}
</style>

<script>
	export default {
		name: 'transition-fade'
	};
</script>
